

















































import Vue from "vue";
import MoneyInput from "@/components/MoneyInput.vue";
import * as api from "../services/api";
import { InvoiceItem, InvoiceItemOtherCost } from "../models";

export default Vue.extend({
  name: "OtherCostForm",
  components: { MoneyInput },
  props: {
    item: { type: Object as () => InvoiceItem, required: true },
    invoiceId: { type: Number, required: true },
    isPageDisabled: { type: Boolean, default: false },
  },
  data() {
    return {
      rows: this.item.otherCosts.map((c) => ({ ...c })) as InvoiceItemOtherCost[],
      isSaving: false,
    };
  },
  computed: {
    currency(): string {
      return this.item.currency ?? "HUF";
    },
  },
  mounted() {
    this.$nextTick(() => {
      const first = this.$el.querySelector<HTMLInputElement>("input");
      first?.focus();
      first?.select();
    });
  },
  methods: {
    async save() {
      if (this.isSaving) return;
      this.isSaving = true;
      try {
        await api.saveInvoiceItemOtherCosts(
          this.invoiceId,
          this.item.invoiceItemID,
          this.rows.map((r) => ({ gpartsCostypeRelId: r.gpartsCostypeRelId, netto: r.netto }))
        );
        this.$emit("saved");
      } finally {
        this.isSaving = false;
      }
    },
    async removeAll() {
      if (this.isSaving) return;
      this.isSaving = true;
      try {
        await api.removeInvoiceItemOtherCosts(this.invoiceId, this.item.invoiceItemID);
        this.$emit("saved");
      } finally {
        this.isSaving = false;
      }
    },
  },
});
